import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Categories18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.88381 1.32321C9.39565 0.835053 8.6042 0.835054 8.11604 1.32321L4.82315 4.6161C4.33499 5.10426 4.33499 5.89571 4.82315 6.38387L8.11604 9.67676C8.6042 10.1649 9.39565 10.1649 9.88381 9.67676L13.1767 6.38387C13.6649 5.89571 13.6649 5.10426 13.1767 4.6161L9.88381 1.32321ZM6.06059 5.49999L8.99992 2.56065L11.9393 5.49999L8.99992 8.43932L6.06059 5.49999Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.5735 9.39825L17.5911 14.8808L17.5921 14.8825C18.0377 15.6874 17.4609 16.7392 16.5264 16.745L16.5217 16.7451L10.4736 16.7451C9.53909 16.7392 8.96228 15.6873 9.40798 14.8824L9.40887 14.8808L12.4265 9.39826C12.8792 8.55169 14.1207 8.55167 14.5735 9.39825ZM13.5 10.5586L10.9206 15.2451H16.0794L13.5 10.5586Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.25 13C0.25 10.9289 1.92893 9.25 4 9.25C6.07107 9.25 7.75 10.9289 7.75 13C7.75 15.0711 6.07107 16.75 4 16.75C1.92893 16.75 0.25 15.0711 0.25 13ZM4 10.75C2.75736 10.75 1.75 11.7574 1.75 13C1.75 14.2426 2.75736 15.25 4 15.25C5.24264 15.25 6.25 14.2426 6.25 13C6.25 11.7574 5.24264 10.75 4 10.75Z'
      fill='currentColor'
    />
  </Svg>
);

Categories18.displayName = 'Categories18';
export default Categories18;
